import React from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow, Polygon } from "@react-google-maps/api";
import Geocode from "react-geocode";

Geocode.setApiKey("AIzaSyAQBQ3Jp4bi0F4LnpPKYNhbR4IM2karacs");
Geocode.setLanguage("ro");
Geocode.setRegion("ro");

export default class SesizariForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      center: {
        lat: 45.770100891295044,
        lng: 21.25254172099606
      },
      address: "Poliția Locală Timișoara, Strada Avram Imbroane 54, Timișoara 300129",
      fileSize: ""
    };
  }

  componentDidMount = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(this.getUserLocation, this.userLocationError);
    } else {
      console.log("Geolocation not available");
    }
  };

  geocodeAddress = () => {
    Geocode.fromLatLng(this.state.center.lat, this.state.center.lng).then(
      response => {
        const address = response.results[0].formatted_address;
        this.setState({ address }, () => this.state);
      },
      error => {
        console.error("Geocode error: " + error);
      }
    );
  };

  getUserLocation = position => {
    this.setState({ center: { lat: position.coords.latitude, lng: position.coords.longitude } }, () =>
      this.geocodeAddress()
    );
  };

  userLocationError = error => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.log("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        console.log("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        console.log("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        console.log("An unknown error occurred.");
        break;
    }
  };

  dragMarker = marker => {
    this.setState({ center: { lat: marker.latLng.lat(), lng: marker.latLng.lng() } }, this.geocodeAddress);
  };

  handleInputChange = event => {
    this.setState({ form: { [event.target.name]: event.target.value } }, () => this.state);
  };

  handleFiles = e => {
    let file = e.target.files[0];
    if (file.size > 3000000) {
      this.setState({ fileSize: "Imaginea încărcată depășește limita maximă admisă de 3MB" });
    } else {
      this.setState({ fileSize: "" });
    }
  };

  render() {
    return (
      <form action="" method="POST" encType="multipart/form-data" className="mb-4">
        <input type="hidden" name="address" id="locatie" value={this.state.address} />
        <input type="hidden" name="latitude" id="latitude" value={this.state.center.lat} />
        <input type="hidden" name="longitude" id="longitude" value={this.state.center.lng} />

        <div className="row">
          <div className="col-lg-6 col-md-5 col-sm-12 col-12">
            <div className="form-group" id="map" style={{ height: "100%", minHeight: "300px" }}>
              <LoadScript googleMapsApiKey="AIzaSyAQBQ3Jp4bi0F4LnpPKYNhbR4IM2karacs">
                <GoogleMap mapContainerStyle={containerStyle} center={this.state.center} zoom={15}>
                  <Marker
                    draggable={true}
                    onDragEnd={this.dragMarker}
                    onClick={this.clickMarker}
                    position={this.state.center}
                    animation={"DROP"}
                  >
                    <InfoWindow position={this.state.center}>
                      <div>
                        <p>{this.state.address}</p>
                      </div>
                    </InfoWindow>
                  </Marker>
                </GoogleMap>
              </LoadScript>
            </div>
          </div>

          <div className="col-lg-6 col-md-7 col-sm-12 col-12">
            <div className="b-shadow top-b p-5">
              <div className="form-group">
                <label htmlFor="topic">Domeniul / departamentul</label>
                <select
                  name="title"
                  className="form-control"
                  id="topic"
                  value={this.state.value}
                  onChange={this.handleInputChange}
                >
                  <option>Nerespectare măsuri anti-Covid/ Intervenții calamități</option>
                  <option>Ordine și liniște publică</option>
                  <option>Oprire/staționare neregulamentară</option>
                  <option>Blocare căi de acces</option>
                  <option>Autovehicule abandonate</option>
                  <option>Protecția mediului</option>
                  <option>Inspecție comercială</option>
                  <option>Disciplina în construcții și afișaj stradal</option>
                  <option>Altele</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="nume">
                  Nume și Prenume <sup className="text-danger">*</sup>
                </label>
                <input
                  name="nume_prenume"
                  type="text"
                  className="form-control"
                  id="nume"
                  onChange={this.handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">
                  Adresă Email <sup className="text-danger">*</sup>
                </label>
                <input
                  name="email"
                  type="email"
                  className="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  onChange={this.handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="nr_telefon">
                  Telefon <sup className="text-danger">*</sup>
                </label>
                <input
                  name="nr_telefon"
                  type="text"
                  className="form-control"
                  id="nr_telefon"
                  aria-describedby="nr_telefon"
                  maxLength="10"
                  onChange={this.handleInputChange}
                  required
                />
              </div>

              <div className="form-group mt-3">
                <label htmlFor="poza-sesizare">Adaugă poza</label>
                <input
                  name="issue_img"
                  type="file"
                  className="form-control-file"
                  id="poza-sesizare"
                  accept="image/*"
                  onChange={this.handleFiles}
                />
                {this.state.fileSize && (
                  <p
                    className="form-text text-danger"
                    data-aos="fade"
                    data-aos-duration="1000"
                    data-aos-once="true"
                  >
                    <strong>{this.state.fileSize}</strong>
                  </p>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="descriere-sesizare">
                  Descrierea situației, dacă nu reiese din poză. Vă rugăm sa furnizați informații cât se poate
                  de concludente! <sup className="text-danger">*</sup>
                </label>
                <textarea
                  name="description"
                  className="form-control"
                  id="descriere-sesizare"
                  rows="3"
                  onChange={this.handleInputChange}
                  required
                ></textarea>
              </div>

              <button
                name="sendReport"
                type="submit"
                className="btn btn-lg btn-primary px-md-5 px-sm-4 px-4"
                disabled={this.state.fileSize}
              >
                <small>Trimite sesizarea</small>
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const containerStyle = {
  width: "1200px",
  maxWidth: "100%",
  height: "100%",
  minHeight: "300px"
};
